module.exports = __webpack_public_path__ + "img/cnu_gallery5.798ab32f.jpg";